export default "__VITE_ASSET__BGh_T_0j__"